var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selector
    ? _c(
        "section",
        [
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _c(
              "div",
              {
                staticClass: "l-selector",
                class: {
                  "l-selector--illustration": _vm.showIllustration,
                },
              },
              [
                _vm.selector && _vm.selector.singleSection === false
                  ? _c("section-navigation", {
                      staticClass: "l-selector__sections",
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showIllustration
                  ? _c("ResidenceIllustration", {
                      staticClass: "l-selector__illustration",
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("ResidenceNavigation", {
                  staticClass: "l-selector__filter",
                }),
                _vm._v(" "),
                _c("ResidenceList", { staticClass: "l-selector__list" }),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }